export default "__VITE_ASSET__dfd8664b__"